module.exports = __webpack_public_path__ + "img/top3.fe511e60.png";